export enum IdentityVerificationMethod {
  ONLINE = 'ONLINE',
  ALTERNATE = 'ALTERNATE',
  CLRDCHECK = 'CLRDCHECK',
  BANKREF = 'BANKREF',
  MCP = 'MCP',
}

export const NON_MODIFIABLE_METHODS: readonly IdentityVerificationMethod[] = [
  IdentityVerificationMethod.ONLINE,
  IdentityVerificationMethod.MCP,
];

export const shouldLockPreviousSteps = (method?: IdentityVerificationMethod | string): boolean =>
  NON_MODIFIABLE_METHODS.includes(method as IdentityVerificationMethod);
